<form [formGroup]="unSelectionCoverage">
  <axis-card>
    <axis-card-body>
      <h1 class="axis-h3">State Disclosures</h1>
      <div class="axis-grid _align-items-middle _row-gap">
        <div class="axis-col-sm-auto">
          <button
            axis-button
            class="kind-primary"
            (click)="modalStateReview.open()"
            aria-label="Open Modal"
          >
            <span class="axis-btn-icon-text">Review State Disclosures</span>
          </button>
        </div>
        <div class="axis-col-sm">
          <axis-media>
            <axis-media-left>
              @if (notReadAlert) {
                @if (firstTimeView) {
                  <axis-icon
                    font="custom"
                    icon="danger"
                    class="_text-warning"
                  ></axis-icon>
                } @else {
                  <axis-icon
                    font="custom"
                    icon="danger"
                    class="_text-danger"
                  ></axis-icon>
                }
              } @else {
                <axis-icon
                  font="custom"
                  icon="success"
                  class="_text-success"
                ></axis-icon>
              }
            </axis-media-left>
            <axis-media-body class="_text-italic">
              @if (notReadAlert) {
                You must read and review the Summary of State Disclosures before continuing.
              } @else {
                I confirm that I have reviewed the Summary of State Disclosures.
              }
            </axis-media-body>
          </axis-media>
        </div>
      </div>
    </axis-card-body>
  </axis-card>
  <!-- Account section -->
  <axis-card>
    <axis-card-body>
      <h2 class="axis-h3">Account Details</h2>
      <div class="axis-grid axis-form-row">
        <div class="axis-col-sm-6">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              for="insuredAuthName"
              >Insured Authorized Representative Name
            </label>
            <div class="axis-form-control-static">{{ unSelectionCoverage.get("unSelectInsuredName").value }}</div>
          </div>
        </div>
        <div class="axis-col-sm-6">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              for="insuredAuthTitle"
              >Insured Authorized Representative Title
            </label>
            <div class="axis-form-control-static">{{ unSelectionCoverage.get("unSelectInsuredAuthName").value }}</div>
          </div>
        </div>
        <div class="axis-col-sm-6">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              for="insuredPolicyName"
              >Company/Insured Name As On Policy
            </label>
            <div class="axis-form-control-static">{{ unSelectionCoverage.get("unSelectInsuredPolicy").value }}</div>
          </div>
        </div>
        <div class="axis-col-sm-6 axis-col-lg-3">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              for="businessMail"
              >Business Email Address
            </label>
            <div class="axis-form-control-static">{{ unSelectionCoverage.get("unSelectBusinessMail").value }}</div>
          </div>
        </div>
        <div class="axis-col-sm-6 axis-col-lg-3">
          <div
            class="axis-form-group"
            [ngClass]="{
              'has-axis-error':
                unSelectionCoverage.get('unSelectBusinessNum')?.invalid &&
                unSelectionCoverage.get('unSelectBusinessNum')?.touched,
            }"
          >
            <label
              class="axis-control-label"
              for="businessPhoneNum"
            >
              Business Phone Number
            </label>
            <input
              autocomplete="off"
              axis-input-clear
              type="text"
              class="axis-form-control"
              id="businessPhoneNum"
              formControlName="unSelectBusinessNum"
            />
            <div
              class="axis-error-block"
              id="businessPhoneNum"
              *ngIf="
                unSelectionCoverage.get('unSelectBusinessNum')?.invalid &&
                unSelectionCoverage.get('unSelectBusinessNum')?.touched
              "
            >
              Please enter a valid Business Phone Number (10 digits).
            </div>
          </div>
        </div>
        <div class="axis-col-sm-6">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              for="streetAddress"
              >Business Street Address
            </label>
            <div class="axis-form-control-static">{{ unSelectionCoverage.get("unSelectBusinessAdd").value }}</div>
          </div>
        </div>
        <div class="axis-col-sm-6 axis-col-lg-3">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              for="businessCity"
              >Business City
            </label>
            <div class="axis-form-control-static">{{ unSelectionCoverage.get("unSelectBusinessCity").value }}</div>
          </div>
        </div>
        <div class="axis-col-sm-6 axis-col-lg-3">
          <div class="axis-form-group">
            <label
              class="axis-control-label"
              for="businessState"
              >Business State
            </label>
            <div class="axis-form-control-static">{{ unSelectionCoverage.get("unSelectBusinessState").value }}</div>
          </div>
        </div>
      </div>
    </axis-card-body>
  </axis-card>
  <!-- Garaging Section -->
  @if (hasGarageStates) {
    <axis-card>
      <axis-card-body>
        <h2 class="axis-h3">{{ garageStatesData?.title }}</h2>
        <div
          class="axis-form-group control-auto-height has-axis-required"
          [ngClass]="{
            'has-axis-error':
              unSelectionCoverage.get('garagingSelection')?.invalid &&
              unSelectionCoverage.get('garagingSelection')?.touched,
          }"
          [ngClass]="{
            'has-axis-required':
              unSelectionCoverage.get('garagingSelection')?.value?.value === '' ||
              unSelectionCoverage.get('garagingSelection')?.value?.value === undefined ||
              unSelectionCoverage.get('garagingSelection')?.value?.value === null,
          }"
        >
          <axis-radio-button-wrapper formControlName="garagingSelection">
            @for (option of garageStatesData?.garagingOptions; track option) {
              <axis-media class="align-top">
                <axis-media-left>
                  <axis-radio
                    [checked]="checkPreselect(option)"
                    heading="{{ option.label }}"
                    name="garaging"
                    value="{{ option.value }}"
                    class="inline"
                    (changeDetect)="patchValue('garagingSelection', option.value)"
                  >
                  </axis-radio>
                </axis-media-left>
              </axis-media>
            }
          </axis-radio-button-wrapper>
          <div
            class="axis-error-block"
            *ngIf="
              unSelectionCoverage.get('garagingSelection')?.invalid &&
              unSelectionCoverage.get('garagingSelection')?.touched
            "
          >
            Please select a garaging option.
          </div>
        </div>
      </axis-card-body>
    </axis-card>
  }
  <!-- UI/UM Section -->
  <axis-card>
    <axis-card-body>
      <h2 class="axis-h3">{{ data?.title }}</h2>
      <p class="axis-h5">
        Please make your coverage selections.
        <span class="_text-italic _text-bold">
          Please note that if your selection differs from the broker submission, there may be an impact to
          premium.</span
        ><span
          aria-hidden="true"
          class="axis-required-indicator"
          >*</span
        >
      </p>
      @if (selectedOption === "minimum") {
        <axis-alert class="kind-info">
          <p>Please note this selection may lead to an increased premium.</p>
        </axis-alert>
      }
      <div
        class="axis-form-group control-auto-height has-axis-required"
        [ngClass]="{
          'has-axis-error':
            unSelectionCoverage.get('bodilyInjurySelection')?.invalid &&
            unSelectionCoverage.get('bodilyInjurySelection')?.touched,
        }"
        [ngClass]="{
          'has-axis-required':
            unSelectionCoverage.get('bodilyInjurySelection')?.value?.value === '' ||
            unSelectionCoverage.get('bodilyInjurySelection')?.value?.value === undefined ||
            unSelectionCoverage.get('bodilyInjurySelection')?.value?.value === null,
        }"
      >
        <axis-radio-button-wrapper formControlName="bodilyInjurySelection">
          @for (option of data?.bodilyInjuryOptions; track option) {
            <axis-media class="align-top">
              <axis-media-left>
                <axis-radio
                  [checked]="checkPreselect(option)"
                  heading="{{ option.label }}"
                  name="bodilyInjury"
                  value="{{ option.value }}"
                  class="inline"
                  (changeDetect)="patchValue('bodilyInjurySelection', option.value)"
                >
                </axis-radio>
              </axis-media-left>
              <axis-media-body>
                <app-tooltip-label
                  content="{{ option.tooltip }}"
                  width="400px"
                  ariaLabel="Info"
                ></app-tooltip-label>
              </axis-media-body>
            </axis-media>
          }
        </axis-radio-button-wrapper>
        <div
          class="axis-error-block"
          *ngIf="
            unSelectionCoverage.get('bodilyInjurySelection')?.invalid &&
            unSelectionCoverage.get('bodilyInjurySelection')?.touched
          "
        >
          Please select Bodily Injury option.
        </div>
      </div>
      <div
        class="axis-form-group control-auto-height has-axis-required"
        [ngClass]="{
          'has-axis-error':
            unSelectionCoverage.get('propertyDamageSelection')?.invalid &&
            unSelectionCoverage.get('propertyDamageSelection')?.touched,
        }"
        [ngClass]="{
          'has-axis-required':
            unSelectionCoverage.get('propertyDamageSelection')?.value?.value === '' ||
            unSelectionCoverage.get('propertyDamageSelection')?.value?.value === undefined ||
            unSelectionCoverage.get('propertyDamageSelection')?.value?.value === null,
        }"
      >
        <label class="axis-control-label"
          >UM/UIM Property Damage Coverage<span
            aria-hidden="true"
            class="axis-required-indicator"
            >*</span
          >
          <app-tooltip-label
            [content]="'Some states make provisions for UM/UIM property damage coverage.'"
            width="400px"
            ariaLabel="More Info"
          ></app-tooltip-label>
        </label>
        <axis-radio-button-wrapper formControlName="propertyDamageSelection">
          @for (option of data?.propertyDamageOptions; track option) {
            <axis-media class="align-top">
              <axis-media-left>
                <axis-radio
                  [checked]="checkPreselect(option)"
                  heading="{{ option.label }}"
                  name="propertyDamage"
                  value="{{ option.value }}"
                  class="inline"
                  (changeDetect)="patchValue('propertyDamageSelection', option.value)"
                ></axis-radio>
              </axis-media-left>
              <axis-media-body>
                <app-tooltip-label
                  content="{{ option.tooltip }}"
                  width="400px"
                  ariaLabel="Info"
                ></app-tooltip-label>
              </axis-media-body>
            </axis-media>
          }
        </axis-radio-button-wrapper>
        <div
          class="axis-error-block"
          *ngIf="
            unSelectionCoverage.get('propertyDamageSelection').invalid &&
            unSelectionCoverage.get('propertyDamageSelection').touched
          "
        >
          Please select Property Damage Coverage option.
        </div>
      </div>
      @if (!isPolicyLiabilityLimitsSelected) {
        <axis-card class="size-small">
          <axis-card-body>
            @for (group of data?.groups; track group) {
              <div
                class="axis-form-group control-auto-height has-axis-required"
                [ngClass]="{
                  'has-axis-error':
                    unSelectionCoverage.get(group.name)?.invalid && unSelectionCoverage.get(group.name)?.touched,
                }"
                [ngClass]="{
                  'has-axis-required':
                    unSelectionCoverage.get(group.name)?.value?.value === '' ||
                    unSelectionCoverage.get(group.name)?.value?.value === undefined ||
                    unSelectionCoverage.get(group.name)?.value?.value === null,
                }"
              >
                <label class="axis-control-label"
                  >{{ group.label
                  }}<span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                  <app-tooltip-label
                    content="{{ group.tooltip }}"
                    width="400px"
                    ariaLabel="More Info"
                  ></app-tooltip-label>
                </label>
                <axis-radio-button-wrapper [formControlName]="group.name">
                  @for (option of group.options; track option) {
                    <axis-radio
                      heading="{{ option.label }}"
                      name="{{ group.name }}"
                      value="{{ option.value }}"
                      class="inline"
                      (changeDetect)="patchValue(group.name, option.value)"
                    >
                    </axis-radio>
                  }
                </axis-radio-button-wrapper>
                <div
                  class="axis-error-block"
                  *ngIf="unSelectionCoverage.get(group.name)?.invalid && unSelectionCoverage.get(group.name)?.touched"
                >
                  Please select an option for {{ group.label }}.
                </div>
              </div>
            }
          </axis-card-body>
        </axis-card>
      }
    </axis-card-body>
  </axis-card>
  <div class="axis-btn-wrapper">
    <div class="axis-btn-wrapper-left">
      <button
        axis-button
        class="kind-secondary"
        (click)="onBack()"
      >
        <span class="axis-btn-icon-text">Back</span>
      </button>
    </div>
    <div class="axis-btn-wrapper-right">
      <button
        axis-button
        class="kind-primary"
        (click)="onContinue()"
      >
        <span class="axis-btn-icon-text">Continue</span>
      </button>
    </div>
  </div>
  <app-modal-uimui-review-state-pdf
    #modalStateReview
    [uninsuredSelection]="unSelectionCoverage"
    (modalResult)="onModalContiueClose($event)"
  ></app-modal-uimui-review-state-pdf>
</form>
